import SimpleModal from 'components/global/SimpleModal';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { handleSubmitDocumentDeleteSubmit } from 'components/views/FounderVault/_helpers/founderVault.events';
import { $form, $view } from 'signals/global.signals';

const FounderDocumentsDeleteModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-document-delete'}
    title="Delete Document"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitDocumentDeleteSubmit}
    primaryButtonText="Delete"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <div className="text-white">
      Are you sure you want to delete <b>{`${$form.value.name}`}</b>?
    </div>
  </SimpleModal>
);

export default FounderDocumentsDeleteModal;
